export default [
    {
        path: '/',
        meta: {
            color: "white",
        },
        component: () => import('@/views/main/index')
    },
    {
        path: '/visit',
        component: () => import('@/views/main/visit')
    },
    {
        path: '/exhibitions',
        component: () => import('@/views/main/exhibitions')
    },
    {
        path: '/exhibition/detail',
        component: () => import('@/views/main/exhibitionDetail')
    },
    {
        path: '/public_art',
        component: () => import('@/views/main/publicArt')
    },
    {
        path: '/public_art/detail',
        component: () => import('@/views/main/publicArtDetail')
    },
    {
        path: '/education',
        component: () => import('@/views/main/education')
    },
    {
        path: '/education/detail',
        component: () => import('@/views/main/educationDetail')
    },
    {
        path: '/residency',
        component: () => import('@/views/main/residency')
    },
    {
        path: '/residency/detail',
        component: () => import('@/views/main/residencyDetail')
    },
    {
        path: '/library',
        component: () => import('@/views/main/library')
    },
    {
        path: '/artist/detail',
        component: () => import('@/views/main/artistDetail')
    },
    {
        path: '/archives',
        component: () => import('@/views/main/archives')
    },
    {
        path: '/about',
        component: () => import('@/views/main/about')
    },
    {
        path: '/media',
        component: () => import('@/views/main/media')
    },
    {
        path: '/join',
        component: () => import('@/views/main/join')
    },
    {
        path: '/support',
        component: () => import('@/views/main/support')
    },

];



// WEBPACK FOOTER //
// ./src/router/main.js